export enum Icon {
  Party = 'fa-party-horn',
  Money = 'fa-money-bill-1-wave',
  Dollar = 'fa-sack-dollar',
}

export enum Phrase {
  NiceWork = 'Nice work',
  Horray = 'Hooray',
  GreatJob = 'Great Job',
  TakeHomePay = 'Take Home Pay',
}
